import type { TimberProject } from '../types';
import { compareTimberProjectsByDealMap } from './projectNumberSort';
import type { EnhancedDeal } from '../types';

export interface HubProjectSections {
  estimating: TimberProject[];
  preconstruction: TimberProject[];
  contracted: TimberProject[];
  closed: TimberProject[];
}

export function partitionHubProjects(projects: TimberProject[]): HubProjectSections {
  const active = projects.filter((p) => p.status !== 'completed');
  return {
    estimating: active.filter((p) => p.phase === 'estimating'),
    preconstruction: active.filter((p) => p.phase === 'preconstruction'),
    contracted: active.filter((p) => p.phase === 'contracted' || p.phase === undefined),
    closed: projects.filter((p) => p.status === 'completed'),
  };
}

/** Sort each active section by ascending project number (deal map lookup). */
export function sortHubProjectSections(
  sections: HubProjectSections,
  dealsById: Map<string, EnhancedDeal>,
): HubProjectSections {
  const sort = (list: TimberProject[]) =>
    [...list].sort((a, b) => compareTimberProjectsByDealMap(a, b, dealsById));

  return {
    estimating: sort(sections.estimating),
    preconstruction: sort(sections.preconstruction),
    contracted: sort(sections.contracted),
    closed: sort(sections.closed),
  };
}
